<mat-form-field appearance="outline">
  <mat-label>Show/Hide Columns</mat-label>
  <mat-select multiple [(value)]="value" (selectionChange)="onSelectionChange()">
    <mat-option *ngFor="let col of allColumns" [value]="col.name">
      {{ col.label }}
    </mat-option>
  </mat-select>
</mat-form-field>

